import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ORDER_SUMMARY_COLUMNS } from "../../../../constants/table";
import { APP_PATHS } from "../../../../constants/paths";
import Table from "../../../Table/Table";
import Modal from "../Modal";
import TablePriceCell from "../../../Table/TablePriceCell/TablePriceCell";
import SecondaryButton from "../../SecondaryButton/SecondaryButton";
import PrimaryButton from "../../PrimaryButton/PrimaryButton";
import Price from "../../../Price/Price";
import classes from "./OrderSummaryModal.module.css";

const OrderSummaryModal = (props) => {
  const { isOpen, onClose, onConfirm, total, skus, bundles } = props;

  const bundleRecords = bundles.map((bundle) => ({
    key: bundle.id,
    name: (
      <div className={classes["order-summary-table__item-name"]}>
        <p className={classes["order-summary-table__item-name-title"]}>
          مجموعة عرض
        </p>
        <ul className={classes["order-summary-table__bundle-skus-list"]}>
          {bundle.skuList.map((sku, index) => (
            <li
              key={index}
              className={classes["order-summary-table__bundle-sku-list-item"]}
            >
              <Link
                to={APP_PATHS.SKU_DETAILS.url.replace(":skuId", sku.skuId)}
                className={classes["order-summary-table__bundle-sku-link"]}
              >
                (<span className="numeric-content">{sku.quantity}</span>){" "}
                {sku.commercialName}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    ),
    price: <TablePriceCell price={bundle.price} />,
    quantity: (
      <span
        className={classNames(
          classes["order-summary-table__quantity"],
          "numeric-content"
        )}
      >
        {bundle.requestedQuantity}
      </span>
    ),
    total: <TablePriceCell price={bundle.requestedQuantity * bundle.price} />,
  }));

  const skuRecords = skus.map((sku) => ({
    key: sku.skuId,
    name: (
      <div className={classes["order-summary-table__item-name"]}>
        <p className={classes["order-summary-table__item-name-title"]}>
          {sku.brandName}
        </p>
        <Link
          to={APP_PATHS.SKU_DETAILS.url.replace(":skuId", sku.skuId)}
          className={classes["order-summary-table__sku-name"]}
        >
          {sku.commercialName}
        </Link>
      </div>
    ),
    price: <TablePriceCell price={sku.suggestedSellingPrice} />,
    quantity: (
      <span
        className={classNames(
          classes["order-summary-table__quantity"],
          "numeric-content"
        )}
      >
        {sku.quantity}
      </span>
    ),
    total: <TablePriceCell price={sku.quantity * sku.suggestedSellingPrice} />,
  }));

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="أكد على طلبك"
      footer={
        <div className={classes["order-summary-modal__footer-content"]}>
          <div className={classes["order-summary-modal__total-wrapper"]}>
            <p className={classes["order-summary-modal__total-text"]}>
              الإجمالي
            </p>
            <Price
              value={total}
              suffix="جم"
              className={classes["order-summary-modal__total-value-wrapper"]}
              valueClassName={classes["order-summary-modal__total-value"]}
              suffixClassName={classes["order-summary-modal__total-currency"]}
            />
          </div>
          <div className={classes["order-summary-modal__footer-actions"]}>
            <SecondaryButton
              className={classes["order-summary-modal__edit-btn"]}
              onClick={onClose}
            >
              تعديل
            </SecondaryButton>
            <PrimaryButton
              withAnimation
              className={classes["order-summary-modal__confirm-btn"]}
              onClick={onConfirm}
            >
              تأكيد عملية الشراء
            </PrimaryButton>
          </div>
        </div>
      }
    >
      <div className={classes["order-summary-modal"]}>
        <div className={classes["order-summary-modal__content"]}>
          <Table
            columns={ORDER_SUMMARY_COLUMNS}
            data={[...bundleRecords, ...skuRecords]}
          />
        </div>
      </div>
    </Modal>
  );
};

export default OrderSummaryModal;

OrderSummaryModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  total: PropTypes.number,
  skus: PropTypes.array,
  bundles: PropTypes.array,
};
